import { useContext } from 'react';
import { Typography } from '@arionbanki/arionui';
import { AppContext } from 'providers/AppProvider';
import { FLOW_TYPE } from 'consts';
import { RiskqTextRRSURow } from './RiskqTextRRSURow';

const PREFIX = `${FLOW_TYPE.RR_SU}_riskq`;

const KEYS = [1, 2, 3].map(i => ({
	title: `${PREFIX}_title_${i}`,
	text: `${PREFIX}_text_${i}`
}));

export function RiskqTextRRSU() {
	const { t } = useContext(AppContext);
	return (
		<>
			<Typography TagName="p">{t(`${PREFIX}_text`, 'riskq')}</Typography>
			{KEYS.map(RiskqTextRRSURow)}
			<Typography TagName="p" className="mb-5">
				{t(`${PREFIX}_description`, 'riskq')}
			</Typography>
		</>
	);
}
